import {
    CloseButton,
    ModalContent,
    ModalWrapper,
    OverlayContainer,
} from "./styled";

const Modal = ({ children, onClose }) => {
    return (
        <ModalWrapper>
            <OverlayContainer onClick={onClose} />

            <ModalContent>
                <CloseButton className="close" onClick={onClose}>
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M13.7172 1.697L12.3032 0.282997L7.0002 5.586L1.6972 0.282997L0.283203 1.697L5.5862 7L0.283203 12.303L1.6972 13.717L7.0002 8.414L12.3032 13.717L13.7172 12.303L8.4142 7L13.7172 1.697Z"
                            fill="#B0B0B0"
                        />
                    </svg>
                </CloseButton>
                {children}
            </ModalContent>
        </ModalWrapper>
    );
};

export default Modal;